import { useEffect, useRef } from 'react';

const COLORS = ['#1e8a87', '#2ba8a4', '#3bbfbb', '#ffffff', '#a3e4e2', '#5cc8c5'];

/**
 * BalloonCanvas — animation canvas plein-écran de ballons qui s'envolent.
 * @param {number}   count   — nombre de ballons (défaut 28)
 * @param {string[]} colors  — palette (défaut palette event2one teal)
 */
function BalloonCanvas({ count = 28, colors = COLORS }) {
    const canvasRef = useRef(null);

    useEffect(() => {
        const canvas = canvasRef.current;
        if (!canvas) return;
        const ctx = canvas.getContext('2d');
        let raf;

        function resize() {
            canvas.width = window.innerWidth;
            canvas.height = window.innerHeight;
        }
        resize();
        window.addEventListener('resize', resize);

        class Balloon {
            constructor(delayed) { this.reset(delayed); }
            reset(delayed) {
                this.x = Math.random() * canvas.width;
                this.y = delayed
                    ? canvas.height + Math.random() * canvas.height
                    : canvas.height + 20 + Math.random() * 60;
                this.r = 14 + Math.random() * 18;
                this.vy = -(0.55 + Math.random() * 0.9);
                this.vx = (Math.random() - 0.5) * 0.5;
                this.wobble = Math.random() * Math.PI * 2;
                this.wobbleSpd = 0.018 + Math.random() * 0.022;
                this.color = colors[Math.floor(Math.random() * colors.length)];
                this.alpha = 0.55 + Math.random() * 0.35;
                this.stringLen = this.r * (1.8 + Math.random() * 1.2);
            }
            update() {
                this.y += this.vy;
                this.wobble += this.wobbleSpd;
                this.x += this.vx + Math.sin(this.wobble) * 0.45;
                if (this.y + this.r + this.stringLen < 0) this.reset(false);
            }
            draw() {
                ctx.save();
                ctx.globalAlpha = this.alpha;
                ctx.beginPath();
                ctx.ellipse(this.x, this.y, this.r, this.r * 1.15, 0, 0, Math.PI * 2);
                ctx.fillStyle = this.color;
                ctx.fill();
                ctx.beginPath();
                ctx.ellipse(
                    this.x - this.r * 0.28, this.y - this.r * 0.32,
                    this.r * 0.22, this.r * 0.14, -0.5, 0, Math.PI * 2
                );
                ctx.fillStyle = 'rgba(255,255,255,0.35)';
                ctx.fill();
                ctx.beginPath();
                ctx.moveTo(this.x, this.y + this.r * 1.15);
                ctx.bezierCurveTo(
                    this.x + this.r * 0.3, this.y + this.r * 1.15 + this.stringLen * 0.4,
                    this.x - this.r * 0.3, this.y + this.r * 1.15 + this.stringLen * 0.7,
                    this.x, this.y + this.r * 1.15 + this.stringLen
                );
                ctx.strokeStyle = this.color;
                ctx.lineWidth = 1;
                ctx.globalAlpha = this.alpha * 0.5;
                ctx.stroke();
                ctx.restore();
            }
        }

        const balloons = Array.from({ length: count }, (_, i) => new Balloon(i > 6));
        function loop() {
            ctx.clearRect(0, 0, canvas.width, canvas.height);
            balloons.forEach(b => { b.update(); b.draw(); });
            raf = requestAnimationFrame(loop);
        }
        loop();

        return () => {
            cancelAnimationFrame(raf);
            window.removeEventListener('resize', resize);
        };
    }, [count, colors]);

    return (
        <canvas
            ref={canvasRef}
            style={{ position: 'fixed', inset: 0, pointerEvents: 'none', zIndex: 0 }}
        />
    );
}

export default BalloonCanvas;
